import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { UPDATE_LISTINGS_FAILURE } from 'modules/authorizations/store/types/homesaleTypes';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { showToast } from 'modules/layout/layout.actions';
import { updateListing } from 'modules/authorizations/store/actions/homesale.actions';
import EditableCard from 'modules/common/editableCard.component';
import React, { useState } from 'react';

const OtherInfoCard = (props) => {

  const [isLoading, setIsLoading] = useState(false);

  const { listingInfo, isReadOnly, id } = props;

  const tabs = [
    { header: 'Other Info', order: 1, iconPath: ['fas', 'file-contract'] },
  ];

  const summaries = [
    { header: 'Listing Agent Name', accessorKey: 'listAgentName', type: 'text', required: false, value: listingInfo ? listingInfo.listAgentName : '', tab: 1 },
    { header: 'Listing Agent Phone', accessorKey: 'listAgentPhone', type: 'text', required: false, value: listingInfo ? listingInfo.listAgentPhone : '', tab: 1 },
    { header: 'Listing Agent Email', accessorKey: 'listAgentEmail', type: 'text', required: false, value: listingInfo ? listingInfo.listAgentEmail : '', tab: 1 },
    { header: 'Goal to List On', accessorKey: 'goalListOn', type: 'date', required: false, value: listingInfo ? listingInfo.goalListOn : '', tab: 1 },
    { header: 'Send Broker Info On', accessorKey: 'sendBrokerInfoOn', type: 'date', required: false, value: listingInfo ? listingInfo.sendBrokerInfoOn : '', tab: 1 },
    { header: 'MLS Link', accessorKey: 'mlsLink', type: 'text', required: false, value: listingInfo ? listingInfo.mlsLink : '', tab: 1 },
  ];

  const updateFields = async (tab, values) => {
    setIsLoading(true);

    let newValues = { ...listingInfo };

    newValues.listAgentName = values.listAgentName;
    newValues.listAgentPhone = values.listAgentPhone;
    newValues.listAgentEmail = values.listAgentEmail;
    newValues.goalListOn = values.goalListOn === '' ? null : values.goalListOn;
    newValues.sendBrokerInfoOn = values.sendBrokerInfoOn === '' ? null : values.sendBrokerInfoOn;
    newValues.mlsLink = values.mlsLink;

    const resp = await props.updateListing(newValues, id);
    if (resp.type === UPDATE_LISTINGS_FAILURE) {
      props.showToast('Failed to update broker info, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      setIsLoading(false);
      return false;
    } else { 
      setIsLoading(false);
      return true; 
    }
  };
    
  return (
    <EditableCard
      tabs={tabs}
      summaries={summaries}
      numColumns={3} 
      updateFields={updateFields}
      isLoading={isLoading}
      hideEdit={isReadOnly}
    />
  );

};

export default compose(
  connect(null, {
    updateListing,
    showToast,
  }),
)(OtherInfoCard);